module.exports = __webpack_public_path__ + "static/img/project-xmg.f4868ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-xmg.png
// module id = smIP
// module chunks = 0